import { get } from './http';

export interface DictItem {
  code: string;
  label: string;
  value: string;
  sortOrder: number;
  isDefault: boolean;
  isEnabled: boolean;
  color?: string | null;
  icon?: string | null;
  ext?: unknown;
  remark?: string | null;
}

interface DictItemResponse {
  dictCode: string;
  orderMode?: 'sort' | 'lex';
  items: DictItem[];
}

export type DictOrderMode = 'sort' | 'lex';

export function fetchDictItems(
  dictCode: string,
  includeDisabled = false,
  orderMode: DictOrderMode = 'sort',
) {
  return get<DictItemResponse>(`/dicts/${dictCode}/items`, {
    params: {
      includeDisabled: includeDisabled ? 1 : 0,
      orderMode,
    },
  });
}

export function fetchDictBatch(
  dictCodes: string[],
  includeDisabled = false,
  orderMode: DictOrderMode = 'sort',
) {
  return get<Record<string, DictItem[]>>('/dicts/batch', {
    params: {
      codes: dictCodes.join(','),
      includeDisabled: includeDisabled ? 1 : 0,
      orderMode,
    },
  });
}

